import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  usuario: any = JSON.parse(localStorage.getItem('usuario'));
  configuracion: any = JSON.parse(localStorage.getItem('configuracion'));

  API_PATH = environment.API_PATH;

  constructor() { }

  ngOnInit() {
    
  }

}
